// features/quantitySlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  inputValue: "",
  displayValue: "",
  quantityError: "",
  quantity: 0, // Add the quantity property to store the calculated value
};

const quantitySlice = createSlice({
  name: "quantity",
  initialState,
  reducers: {
    setInputValue: (state, action) => {
      state.inputValue = action.payload;
    },
    setDisplayValue: (state, action) => {
      state.displayValue = action.payload;
    },
    setError: (state, action) => {
      state.quantityError = action.payload;
    },
    setQuantity: (state, action) => {
      state.quantity = action.payload; // Manage the quantity directly in Redux
    },
    resetQuantityState: (state) => {
      state.inputValue = "";
      state.displayValue = "";
      state.quantityError = "";
      state.quantity = 0; // Reset the quantity
    },
  },
});

export const { setInputValue, setDisplayValue, setError, setQuantity, resetQuantityState } =
  quantitySlice.actions;

export const selectQuantity = (state) => state.quantity;

export default quantitySlice.reducer;
